import { render, staticRenderFns } from "./form_star_tax_report_component.vue?vue&type=template&id=afc88ab6&scoped=true"
import script from "./form_star_tax_report_component.vue?vue&type=script&lang=js"
export * from "./form_star_tax_report_component.vue?vue&type=script&lang=js"
import style0 from "./form_star_tax_report_component.vue?vue&type=style&index=0&id=afc88ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc88ab6",
  null
  
)

export default component.exports